import ReporterService from '../../client-server-utils/ReporterService';
import ReporterServiceContext from '../../contexts/ReporterServiceContext';
import { withContext } from './withContext';

export default withContext(ReporterServiceContext, 'reporterService');

export type withReporterServiceContextProps = {
  reporterService: ReporterService;
};
